import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Alert,
} from "@mui/material";

function DeviceOrderDialog({ open, formData, onChange, onCancel, onSubmit }) {
  const handleFieldChange = (name, value) => {
    onChange({
      ...formData,
      [name]: value,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      disableScrollLock
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
        },
      }}
    >
      <DialogTitle>Order Remote Monitoring Device</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="device-type-label">Device Type</InputLabel>
          <Select
            labelId="device-type-label"
            id="device-type-select"
            label="Device Type"
            value={formData.device_type}
            onChange={(e) => handleFieldChange("device_type", e.target.value)}
            data-testid="device-type-select"
            data-field-name="device_type"
          >
            <MenuItem value="bp_monitor" data-testid="device-type-bp-monitor">Blood Pressure Monitor</MenuItem>
            <MenuItem value="glucose_meter" data-testid="device-type-glucose-meter">Glucose Meter</MenuItem>
            <MenuItem value="pulse_ox" data-testid="device-type-pulse-ox">Pulse Oximeter</MenuItem>
            <MenuItem value="weight_scale" data-testid="device-type-weight-scale">Smart Weight Scale</MenuItem>
            <MenuItem value="thermometer" data-testid="device-type-thermometer">Smart Thermometer</MenuItem>
            <MenuItem value="ecg_monitor" data-testid="device-type-ecg-monitor">ECG/Heart Monitor</MenuItem>
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="Device Name (optional)"
          value={formData.device_name}
          onChange={(e) => handleFieldChange("device_name", e.target.value)}
          sx={{ mt: 2 }}
          placeholder="Specific model or brand"
          data-testid="device-name-input"
          aria-label="Device name or model"
          data-field-name="device_name"
        />
        <TextField
          fullWidth
          label="Special Instructions"
          multiline
          rows={2}
          value={formData.notes}
          onChange={(e) => handleFieldChange("notes", e.target.value)}
          placeholder="e.g., Leave at front desk, Call before delivery..."
          sx={{ mt: 2 }}
          data-testid="device-instructions-input"
          aria-label="Special delivery instructions"
          data-field-name="device_instructions"
        />
        <Alert severity="info" sx={{ mt: 2 }}>
          Device will be shipped within 1-2 business days. Patient will receive setup instructions via
          email and SMS.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onCancel}
          data-testid="device-order-cancel-button"
          aria-label="Cancel device order"
        >
          Cancel
        </Button>
        <Button 
          variant="contained" 
          onClick={onSubmit}
          data-testid="device-order-submit-button"
          aria-label="Submit device order"
        >
          Order Device
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DeviceOrderDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  formData: PropTypes.shape({
    device_type: PropTypes.string,
    device_name: PropTypes.string,
    notes: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default DeviceOrderDialog;
